import { MoneyConnectClientAPI } from "./axios-service-creator";

export const NotificationAPI = {
  getNotification: () => MoneyConnectClientAPI.post("/notification/noti", {}),
};
